import React from 'react';
import AnswerState from '../constants/types';
import useProofOfWorkContext from '../hooks/useProofOfWorkContext';

type Props = {
  answerState: AnswerState;
};

const ChallengeView: React.FC<Props> = ({ answerState }: Props) => {
  const {
    state: { resources }
  } = useProofOfWorkContext();

  switch (answerState) {
    case AnswerState.VERIFIED_CORRECT: {
      return (
        <React.Fragment>
          <div className='pow-footer'> {resources.Description.ChallengeValidated} </div>
        </React.Fragment>
      );
    }
    case AnswerState.VERIFIED_INCORRECT: {
      return (
        <React.Fragment>
          <div className='pow-footer'> {resources.Description.ChallengeValidated} </div>
        </React.Fragment>
      );
    }
    case AnswerState.COMPUTING: {
      return (
        <React.Fragment>
          <div className='pow-footer'>
            <p> {resources.Description.VerifyingYouAreNotBot} </p>
            <span className='spinner spinner-default spinner-no-margin modal-margin-bottom-large' />
          </div>
        </React.Fragment>
      );
    }
    case AnswerState.COMPUTING_DONE: {
      return (
        <React.Fragment>
          <div className='pow-footer'>
            <div className='label-checkmark' />
          </div>
        </React.Fragment>
      );
    }
    default: {
      return (
        <React.Fragment>
          <div className='pow-footer'>
            <p> {resources.Description.VerifyingYouAreNotBot} </p>
          </div>
        </React.Fragment>
      );
    }
  }
};

export default ChallengeView;
